import { DirectiveBinding } from 'vue';
import { useEventListener } from '@vueuse/core';

const showTooltipFun = (tooltipNode: any, el: HTMLElement) => {
  return () => {
    tooltipNode.component.props.popupVisible = false; // 默认不使用tooltip
    const ellipsiDom = el.children?.[0] as HTMLElement;
    const range = document.createRange();
    range.setStart(ellipsiDom, 0);
    range.setEnd(ellipsiDom, ellipsiDom.childNodes.length);
    const rangeWidth = Math.round(range.getBoundingClientRect().width);
    const rangeHeight = Math.round(range.getBoundingClientRect().height);
    const paddingX =
      (parseInt(ellipsiDom?.style?.paddingLeft, 10) || 0) +
      (parseInt(ellipsiDom?.style?.paddingRight, 10) || 0);
    const paddingY =
      (parseInt(ellipsiDom?.style?.paddingTop, 10) || 0) +
      (parseInt(ellipsiDom?.style?.paddingBottom, 10) || 0);
    if (
      rangeWidth + paddingX > ellipsiDom.offsetWidth ||
      rangeHeight + paddingY > ellipsiDom.offsetHeight ||
      ellipsiDom.scrollWidth > ellipsiDom.offsetWidth ||
      ellipsiDom.scrollHeight > ellipsiDom.offsetHeight
    ) {
      // 当文本滚动宽度/高度超过dom自身宽度/高度时使用tooltip
      tooltipNode.component.props.popupVisible = undefined;
    }
  };
};
// 控制文本过长截断并tooltip显示
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: any) {
    const tooltipNode = vnode.children.find(
      (childCmpt: any) => childCmpt?.component?.type?.name === 'Tooltip'
    );
    if (tooltipNode) {
      useEventListener(el, 'mouseenter', showTooltipFun(tooltipNode, el));
    }
  },
};
